import { render, staticRenderFns } from "./CompanyIcons.vue?vue&type=template&id=1d60f41c&scoped=true&"
import script from "./CompanyIcons.vue?vue&type=script&lang=js&"
export * from "./CompanyIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d60f41c",
  null
  
)

export default component.exports